import axios from "@/libs/api.request";
import { user, home } from "./api_url";
/**
 * 登录接口
 * @param data
 * @returns {*|{responseURL}}
 */
export const login = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.login,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 退出登录
 * @param token
 * @returns {*|{responseURL}}
 */
export const logout = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.logout,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 注册商家账号
 */
export const register = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.register,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 找回密码
 */
export const Forgot = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.Forgot,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取短信验证码
 */
export const getsms = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.getsms,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 邮箱获取验证码
 */
export const GetEmall = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.GetEmall,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取当前用户信息
 * @param token
 * @returns {*|{responseURL}}
 */
export const getUserInfo = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.getUserInfo,
    data: params,
    method: "post"
  });
};
/**
 * 获取地区省市县
 */
export const getregion = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.getregion,
    data: params,
    method: "post"
  });
};
/**
 * 修改密码
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */
export const UpdPWD = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.UpdPWD,
    data: params,
    method: "post"
  });
};
/**
 * 修改查看工资密码
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */
export const UpdPWDWage = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.UpdPWDWage,
    data: params,
    method: "post"
  });
};
/**
 * 设置登录人座右铭
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */
export const SetMotto = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.SetMotto,
    data: params,
    method: "post"
  });
};

export const getUnreadCount = () => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/count",
    method: "get"
  });
};

export const getMessage = () => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/init",
    method: "get"
  });
};

export const getContentByMsgId = msg_id => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/content",
    method: "get",
    params: {
      msg_id
    }
  });
};

export const hasRead = msg_id => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/has_read",
    method: "post",
    data: {
      msg_id
    }
  });
};

export const removeReaded = msg_id => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/remove_readed",
    method: "post",
    data: {
      msg_id
    }
  });
};

export const restoreTrash = msg_id => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: "message/restore",
    method: "post",
    data: {
      msg_id
    }
  });
};
/**
 * 获取菜单
 * @param params
 * @returns {*|{responseURL}}
 */
export const login_success_permission = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.login_success_permission,
    method: "get",
    params: params
  });
};
/**
 * 设置头像
 * @param params
 * @returns {*|{responseURL}}
 * @constructor
 */
export const SetAvatar = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.SetAvatar,
    method: "post",
    data: params
  });
};
/**
 * savebaseinfo //保存基本信息
 */
export const savebaseinfo = params => {
  let country_code = localStorage.getItem("country_code");

  return axios.request({
    url: user.savebaseinfo,
    method: "post",
    data: params
  });
};
/**
 * 19.实名认证
 * @param params
 * @returns {*}
 */
export const real_name_auth = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.real_name_auth,
    method: "post",
    data: data
  });
};
/**
 * 20.企业认证
 * @param params
 * @returns {*}
 */
export const enterprise = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.enterprise,
    method: "post",
    data: data
  });
};
/**
 * changeaccount 变更账号
 */
export const changeaccount = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.changeaccount,
    method: "post",
    data: params
  });
};
/**
 * 企业认证倒计时
 * @param params
 * @returns {*}
 */
export const enterprise_audit_count_down = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.enterprise_audit_count_down,
    method: "post",
    data: params
  });
};
/**
 * 实名认证倒计时
 * @param params
 * @returns {*}
 */
export const realname_audit_count_downr = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: user.realname_audit_count_downr,
    method: "post",
    data: params
  });
};
/**
 * 首页总览统计数据
 * @param params
 * @returns {*}
 */
export const index_overview = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.index_overview,
    method: "post",
    data: params
  });
};
/**
 * 服务统计数据
 * @param params
 * @returns {*}
 */
export const service_overview = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.service_overview,
    method: "post",
    data: params
  });
};
/**
 * 用户统计数据
 * @param params
 * @returns {*}
 */
export const user_overview = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.user_overview,
    method: "post",
    data: params
  });
};
/**
 * 产品统计数据
 * @param params
 * @returns {*}
 */
export const product_overview = params => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: home.product_overview,
    method: "post",
    data: params
  });
};
